import * as actionTypes from '../actions/actionTypes';
import { PAYMENT_STATUS } from '../../const/payment/PAYMENT_STATUS';
import { PAYMENT_TYPE } from '../../const/payment/PAYMENT_TYPE';

const initialState = {
    paymentOptions: null,
    paymentOptionsError: null,
    status: PAYMENT_STATUS.PENDING,
    bookingID: null,
    paymentURL: null,
    error: null,
    confirmPaymentProgres: false,
};

const reducer = (state = initialState, {type, ...payload}) => {
    switch (type) {
        case actionTypes.GET_PAYMENT_OPTIONS:
            return {
                ...state,
                bookingID: null,
                paymentURL: null
            }
        case actionTypes.GET_PAYMENT_OPTIONS_SUCCEEDED:
            const {paymentOptions} = payload;
            return {
                ...state,
                paymentOptions
            };
        case actionTypes.GET_PAYMENT_OPTIONS_FAILED:
            const {message} = payload;
            return {
                ...state,
                paymentOptionsError: message
            };
        case actionTypes.UPDATE_PAYMENT_STATUS:
            const {status} = payload;
            if (status === PAYMENT_STATUS.CANCEL && !state.bookingID) {
                return state;
            }

            return {
                ...state,
                status,
                bookingID: null,
                popUpWindow: null
            };
        case actionTypes.CONFIRM_PAYMENT:
            return {
                ...state,
                bookingID: null,
                confirmPaymentProgres: true,
            };
        case actionTypes.SET_PAYMENT_URL:
            return {
                ...state,
                paymentURL: payload.paymentUrl,
                confirmPaymentProgres: false,
            };
        case actionTypes.CONFIRM_PAYMENT_ERROR:
            return {
                ...state,
                error: payload.error,
                status: PAYMENT_STATUS.ERROR,
                confirmPaymentProgres: false,
            };
        case actionTypes.CONFIRM_PAYMENT_SUCCEEDED:
            const { payload: { id, paymentType, onlinePayment } } = payload;
            return {
                ...state,
                bookingID: id,
                status: (paymentType === PAYMENT_TYPE.IDEAL || onlinePayment) ? PAYMENT_STATUS.PENDING : PAYMENT_STATUS.OK,
                confirmPaymentProgres: false,
            };
        default:
            return state;
    }
};

export default reducer;